import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@jira/navigation-apps__resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { opsgenieScheduleRedirectRoute } from '@jira/router-routes__opsgenie-schedule-routes/src/opsgenieScheduleRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import OpsgenieSchedule, { LazyOpsGenieSchedule, OpsgenieScheduleRedirect } from './ui/index.tsx';

export const opsgenieScheduleRedirectRouteEntry: Route = createEntry(
	opsgenieScheduleRedirectRoute,

	() => ({
		group: 'components',
		// eslint-disable-next-line no-restricted-syntax
		component: !__SERVER__ ? OpsgenieScheduleRedirect : OpsgenieSchedule,
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
		},

		resources: [
			...getBusinessProjectResources(),
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			horizontalNavJiraResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyOpsGenieSchedule],
		isRedirect: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
